import { useState, useEffect } from 'react'
import type { ChannelInfo } from '../types/channel'
import { fetchChannelInfo } from '../utils'

export function useChannelInfo(callLetter: string) {
  const [data, setData] = useState<ChannelInfo | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        if (callLetter !== '') {
          const channelInfo = await fetchChannelInfo(callLetter)
          // Since fetchChannelInfo returns an array, get the first item
          setData(channelInfo)
        }
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [callLetter])

  return { data, isLoading, error }
}
